import { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectNotifications } from '@client-hub/store/slices/notifications/selectors'

import { useTranslation, getI18n } from 'react-i18next'
import { useNotifications } from '@client-hub/shared/react/hooks/notifications'

let displayed: Array<string | number> = []
const Notifier: FC = () => {
  const { t } = useTranslation()
  const notify = useNotifications()

  const dispatch = useDispatch()
  const notifications = useSelector(selectNotifications)

  const storeDisplayed = (id: string | number) => {
    displayed = [...displayed, id]
  }

  useEffect(() => {
    notifications.forEach(({ key, tKey, variant = 'error', ...options }) => {
      if (!getI18n().exists(`api.${tKey}`)) return

      // do nothing if snackbar is already displayed
      if (displayed.includes(key)) return
      notify({ message: t(`api.${tKey}`), variant, ...options })

      // keep track of snackbars that we've displayed
      storeDisplayed(key)
    })
  }, [notifications, dispatch, notify])

  return null
}

export default Notifier
